// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".engines-origins-section.partner[data-v-6efcc017]{height:calc(100vh - 340px)}.engines-origins-section.customer[data-v-6efcc017]{height:calc(100vh - 260px)}", ""]);
// Exports
module.exports = exports;
